import React from 'react';
import { Skeleton, SkeletonBlock, SkeletonContent, SkeletonLine, } from '@one-thd/sui-atomic-components';
export var TopPOJobNameSkeleton = function () {
    return (React.createElement("div", null,
        React.createElement(SkeletonContent, { orientation: "horizontal" },
            React.createElement(SkeletonContent, { initialSize: "1/4", disablePadding: true },
                React.createElement(SkeletonLine, { variant: "heading", fullWidth: true })),
            React.createElement(SkeletonContent, { initialSize: "1/4", disablePadding: true }),
            React.createElement(SkeletonContent, { initialSize: "1/4", disablePadding: true }),
            React.createElement(SkeletonContent, { initialSize: "1/4", disablePadding: true },
                React.createElement(SkeletonLine, { variant: "heading", fullWidth: true }))),
        React.createElement(SkeletonContent, { initialSize: "full" },
            React.createElement(SkeletonLine, { numberOfLines: 4, fullWidth: true }))));
};
/**
 * Skeleton for the Spend By Department Section
 */
export var SpendByDepartmentSkeleton = function () {
    return (React.createElement("div", null,
        React.createElement(SkeletonContent, { orientation: "horizontal" },
            React.createElement(SkeletonContent, { initialSize: "1/4", disablePadding: true },
                React.createElement(SkeletonLine, { variant: "heading", fullWidth: true })),
            React.createElement(SkeletonContent, { initialSize: "1/4", disablePadding: true }),
            React.createElement(SkeletonContent, { initialSize: "1/4", disablePadding: true }),
            React.createElement(SkeletonContent, { initialSize: "1/4", disablePadding: true },
                React.createElement(SkeletonLine, { variant: "heading", fullWidth: true }))),
        React.createElement(SkeletonContent, { initialSize: "full" },
            React.createElement(SkeletonLine, { numberOfLines: 4, fullWidth: true }))));
};
export var SpendMapSkeleton = function () {
    return (React.createElement("div", { className: "sui-grid sui-grid-cols-1 md:sui-gird-cols-2 lg:sui-grid-cols-2" },
        React.createElement("div", { className: "sui-col-span-1" },
            React.createElement(SkeletonContent, { initialSize: "full" },
                React.createElement(SkeletonBlock, { aspect: "wide", height: 60 }))),
        React.createElement("div", { className: "sui-col-span-1" },
            React.createElement(Skeleton, { orientation: "vertical", grow: true },
                React.createElement(SkeletonContent, null,
                    React.createElement(SkeletonContent, { initialSize: "full" },
                        React.createElement(SkeletonLine, { numberOfLines: 4, fullWidth: true })))))));
};
export var TopItemSkeleton = function () {
    return (React.createElement("div", { "data-testid": "top-item-skeleton" }, Array.from({ length: 4 }, function (_event, index) { return (React.createElement("div", { key: "top-item-skeleton-".concat(index) },
        React.createElement(SkeletonContent, { orientation: "horizontal", disablePadding: "x" },
            React.createElement(SkeletonContent, null,
                React.createElement(SkeletonBlock, { aspect: "square", height: 20, width: 20, "data-testid": "bt-skeleton-block" })),
            React.createElement(SkeletonContent, { grow: true },
                React.createElement(SkeletonLine, { fullWidth: true }))))); })));
};
